
import * as math from '../utils/math';
import * as utils from '../utils/utils';
import InspectorInput from './input';
import InspectorStats from './stats';
import InspectorGraphs from './graphs';
import InspectorStylesheets from './stylesheets';
import {FreezeMode} from './freeze';


var Inspector = function(core) {
    this.core = core;
    this.enabled = false;
    this.input = new InspectorInput(this);
    this.stats = new InspectorStats(this);
    this.graphs = new InspectorGraphs(this);
    this.stylesheets = new InspectorStylesheets(this);
    this.freeze = new FreezeMode();

    if (this.core.config.inspector || __DEV__) {
        this.input.init();
    }

    this.shakeCamera = false; 
    this.drawRadar = false;
    this.radarSets = [];
    this.radarCells = null;
    this.radarKey = null;
    this.debugValue = 0;
    this.measureMode = false;
    this.measurePoints = [];

    if (__DEV__) {
        this.input.diagnosticMode = true;
        this.enableInspector();
    }

    // debug* values apply once a map is loaded and on live changes
    core.bus.on('map-loaded', this.applyDebugParams.bind(this));
    core.configStore.watch(debugKeys, this.applyDebugParams.bind(this));
};


Inspector.prototype.enableInspector = function() {
    if (!this.enabled) {
        this.stats.init();
        this.graphs.init();
        this.stylesheets.init();

        //load image    
        if (!this.circleImage) {
            this.circleImage = utils.loadImage(
                    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QAAAAAAAD5Q7t/AAAACW9GRnMAAAAgAAAA4ACD+EAUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA/UlEQVRYw+2VPwqDMBTG3dz1Am56EnH2XLroETxGuwc3Z7cOdhY8QJpfSUBspUvStJAPPggvD973/uQligICAgL+DKViqygUV02hbaXLwJlio7gpyhNu2idzEXwwgfI8H+u6vnZdN/V9P3EuimLcCRlsiyArGcfxjWDLsmzyAGzc4aNFNDZ7/iw7AeQH4LNrh5WZYLgkJTaZCyHuVVVdkiSZ0zSdOWMzlaBFWkRrQ4A4Zk/A4wBie1MFYUMAz0wybCYAmR8FUAlzj6+2r18TgM2VAO8tOB1Cyk7mrofQ+zP0voheVjHtIBjDxjrmvCu7k1Xs/TP6ie84ICDAGR5uCYdPo0MWiAAAAABJRU5ErkJggg==',
                    //"http://maps.google.com/mapfiles/kml/shapes/placemarkcircle.png",
                    (function(){
                        this.circleTexture = this.core.renderer.createTexture({ 'source': this.circleImage });
                    }).bind(this)
                );
        }

        this.core.bus.on('map-update', this.onMapUpdate.bind(this));
        this.enabled = true;
    }
};


Inspector.prototype.setParameter = function(key, value) {
    this.input.setParameter(key, value);
};


// the debug* keys routed to this inspector
var debugKeys = [
    'debugMode', 'debugBBox', 'debugLBox', 'debugNoEarth',
    'debugGridCells', 'debugRadar'
];


/* Applies every non-null debug* value from the config store to the
 * loaded map. Called when a map finishes loading and whenever a
 * debug* key changes; no-op while no map is loaded. */
Inspector.prototype.applyDebugParams = function() {
    if (!this.core.getMap()) {
        return;
    }

    for (var i = 0; i < debugKeys.length; i++) {
        var value = this.core.configStore.get(debugKeys[i]);
        if (value != null) {
            this.setParameter(debugKeys[i], value);
        }
    }
};

Inspector.prototype.addStyle = function(string) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = string;
    document.getElementsByTagName('head')[0].appendChild(style);
};


Inspector.prototype.showNotification = function(message) {
    if (!this.notificationEl) {
        this.notificationEl = document.createElement('div');
        this.notificationEl.id = 'vts-notification';
        document.body.appendChild(this.notificationEl);
    }
    this.notificationEl.textContent = message;
    this.notificationEl.style.opacity = '1';
    clearTimeout(this.notificationTimer);
    this.notificationTimer = setTimeout(function() {
        this.notificationEl.style.opacity = '0';
    }.bind(this), 2000);
};


//used to block mouse events
Inspector.prototype.doNothing = function(e) {
    e.stopPropagation();
    return false;
};


Inspector.prototype.preventDefault = function(e) {
    if (e.preventDefault) {
        e.preventDefault();
    } else {
        e.returnValue = false;
    }
};


Inspector.prototype.onMapUpdate = function() {
    var map = this.core.getMap();
    if (!map) {
        return;
    }

    if (this.shakeCamera) {
        map.redraw();
    } 

    /*if (this.measureMode) {
        var renderer = this.core.getRenderer();
        var p = map.convertCoordsFromPhysToNav(this.measurePoints[0]);
        map.convertCoordsFromPhysToCanvas(this.measurePoints[0]);
    }*/

    var renderer = this.core.renderer, i, li, j, lj, p;
    
    if (!this.drawRadar && this.radarSets.length) {
        for (i = 0, li = this.radarSets.length; i < li; i++)
            map.outerMap.releaseRegisteredSamples(this.radarSets[i]);
        this.radarSets = [];
        this.radarCells = null;
        this.radarKey = null;
    }

    if (this.drawRadar && this.circleTexture) {
        var camera = map.outerMap.camera;
        var count = 16;
        var step = camera.viewExtent / (count * 4);
        var cbuffer = new Array(count * count);

        // the grid's cells are registered terrain samples, one per cell
        // at the cell's own resolution, placed anew when the center or
        // the view extent moved. Every grid stays registered until a
        // newer one is answered, so no answer is lost. The cells are
        // drawn at the current center with the heights of the newest
        // answered grid, which are at most a few frames behind
        var key = camera.center[0] + ' ' + camera.center[1] + ' '
            + camera.viewExtent;

        if (this.radarKey !== key) {
            var probe = camera.clone();
            var cells = new Array(count * count);

            for (j = 0; j < count; j++) {
                for (i = 0; i < count; i++) {
                    var dx =  i*step - count*0.5*step;
                    var dy =  j*step - count*0.5*step;

                    probe.set({ center: camera.center });
                    probe.pan(math.degrees(Math.atan2(dy, dx)),
                        Math.sqrt(dx*dx + dy*dy));
                    cells[j * count + i] = [probe.center[0], probe.center[1]];
                }
            }

            this.radarSets.push(map.outerMap.registerSamples(cells, step));
            this.radarCells = cells;
            this.radarKey = key;
        }

        var sets = this.radarSets, answered = -1;

        for (i = 0, li = sets.length; i < li; i++)
            if (sets[i].generation > 0) answered = i;

        for (i = 0; i < answered; i++)
            map.outerMap.releaseRegisteredSamples(sets[i]);

        if (answered > 0) sets.splice(0, answered);

        var heights = sets[0].sampleHeight;

        for (i = 0, li = cbuffer.length; i < li; i++) {
            var cell = this.radarCells[i];

            // a cell without a height yet is drawn on the datum
            var height = isNaN(heights[i]) ? 0 : heights[i];

            cbuffer[i] = map.convertCoordsFromNavToCanvas(
                [cell[0], cell[1], height]);
        }


        var lbuffer = new Array(count);

        for (j = 0; j < count; j++) {
            for (i = 0; i < count; i++) {
                lbuffer[i] =  cbuffer[j * count + i];
            }
            
            renderer.drawLineString({
                points : lbuffer,
                size : 2.0,
                screenSpace : true,
                color : [0,255,255,255],
                depthTest : false,
                blend : false
            });            
        }


        for (i = 0; i < count; i++) {
            for (j = 0; j < count; j++) {
                lbuffer[j] =  cbuffer[j * count + i];
            }
            
            renderer.drawLineString({
                points : lbuffer,
                size : 2.0,
                screenSpace : true,
                color : [0,255,255,255],
                depthTest : false,
                blend : false
            });            
        }

        for (i = 0, li = cbuffer.length; i < li; i++) {
            p = cbuffer[i];
            renderer.drawImage({
                rect : [p[0]-10, p[1]-10, 20, 20],
                texture : this.circleTexture,
                color : [255,0,255,255],
                depth : p[2],
                depthTest : false,
                blend : true
            });
        }
    }

};


Inspector.prototype.hasFreezeFrustum = function() {
    return this.freeze.active
            && this.freeze.drawFrustum
            && this.freeze.frustumApex
            && this.freeze.frustumBase;
};


Inspector.prototype.drawFreezeFrustum = function() {
    if (this.hasFreezeFrustum()) {
        var legacyMap = this.core.getMap();
        if (legacyMap) {
            this.core.renderer.drawFrustumPyramid(
                this.freeze.frustumApex,
                this.freeze.frustumBase,
                legacyMap.outerMap.camera.geometry.eye);
        }
    }
};


Inspector.prototype.toggleFreeze = function() {
    this.freeze.toggleFrozen(this.core);
};


Inspector.prototype.resetFreezeView = function() {
    this.freeze.resetView(this.core);
};


Inspector.prototype.setFreezeControlsActive = function(active) {
    this.freeze.setControlsActive(this.core, active);
};


Inspector.prototype.toggleFreezeFrustum = function() {
    this.freeze.toggleFrustum(this.core);
};


export default Inspector;
